import React, {MouseEventHandler} from 'react';
import {Button} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import clsx from 'clsx';
import {ButtonSize} from '../../types/Forms';
import {ButtonType} from '@restart/ui/Button';

interface ButtonSubmitProps {
    disabled: boolean;
    isLoading: boolean;
    textId: string;
    size?: ButtonSize;
    type?: ButtonType;
    onClick?: MouseEventHandler | undefined;
}

const ButtonSubmit = ({
    disabled,
    isLoading,
    textId,
    size = 'medium',
    type = 'submit',
    onClick,
}: ButtonSubmitProps): JSX.Element => {
    const intl = useIntl();
    const btnText = intl.formatMessage({id: textId});

    return (
        <Button
            type={type}
            variant="celeste-primary"
            className={clsx({
                'btn-sm': size === 'small',
                'btm-lg': size === 'large',
            })}
            disabled={disabled || isLoading }
            onClick={onClick}
        >
            {!isLoading && <span className="indicator-label">{btnText}</span>}
            {isLoading && (
                <span className="indicator-progress" style={{display: 'block'}}>
                    {btnText}
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
            )}
        </Button>
    );
};
export default ButtonSubmit;
